// File: src/pages/Support/components/DetailItem.js

import React from "react";
import { Typography } from "antd";
import {
  UserOutlined,
  TeamOutlined,
  CalendarOutlined,
} from "@ant-design/icons";

const { Text } = Typography;

/**
 * DetailItem - Reusable field display component
 * Used in UserProfileCard for showing user/ticket information
 *
 * @param {Object} icon - Ant Design icon component (optional)
 * @param {string} label - Field label (uppercase, small text)
 * @param {React.ReactNode} value - Field value (can be string or JSX like Tag)
 */
const DetailItem = ({ icon, label, value }) => (
  <div style={{ marginBottom: 14 }}>
    {/* Label Row */}
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        fontSize: 11,
        fontWeight: 600,
        marginBottom: 4,
        letterSpacing: 0.3,
        textTransform: "uppercase",
      }}>
      {icon && <span style={{ fontSize: 13, }}>{icon}</span>}
      {label}
    </div>

    {/* Value Row */}
    <div
      style={{
        fontSize: 14,
        paddingLeft: icon ? 21 : 0,
        fontWeight: 400,
        lineHeight: 1.5,
      }}>
      {value}
    </div>
  </div>
);

export default DetailItem;
